export const UPSTYLEINDEX = 'UPSTYLEINDEX'



// WEBPACK FOOTER //
// ./src/store/modules/home/market/mutations-type.js